/**
 * 螢幕與視窗尺寸監聽器
 * 負責維護寬高、DPI 限額與發送 Resize 廣播
 */
export default class Sizes {
    constructor() {
        this.width = window.innerWidth
        this.height = window.innerHeight

        this.pixelRatio = Math.min(window.devicePixelRatio, 2)
        this.onResize = null
        this._resizeHandler = this._handleResize.bind(this)
        this._rafId = null

        this._setEventListeners()
    }

    /** 內部 Resize 處理程序（使用 rAF 進行防抖/節流優化） */
    _handleResize() {
        if (this._rafId !== null) {
            return
        }

        this._rafId = requestAnimationFrame(() => {
            this._rafId = null

            const newWidth = window.innerWidth
            const newHeight = window.innerHeight
            const newPixelRatio = Math.min(window.devicePixelRatio, 2)

            if (this.width === newWidth && this.height === newHeight && this.pixelRatio === newPixelRatio) {
                {
                    return
                }
            }

            this.width = newWidth
            this.height = newHeight
            this.pixelRatio = newPixelRatio

            // 廣播給訂閱者
            this.onResize?.()
        })
    }

    /** 綁定視窗事件 */
    _setEventListeners() {
        window.addEventListener('resize', this._resizeHandler)
    }

    /** 解除事件監聽與未完成的 rAF，防止記憶體洩漏 */
    destroy() {
        if (this._rafId !== null) {
            cancelAnimationFrame(this._rafId)
            this._rafId = null
        }
        window.removeEventListener('resize', this._resizeHandler)
    }
}
